import React from "react";
import * as Icon from 'ubs-icons';

/*************************************************************
 * Organized Constants
 ************************************************************ */
export const LENGTH = {
    TAGS: 30,
    SEARCH: 2
}
export const TIMEOUT = {
    TOAST: 5000,
    DE_BOUNCING: 500,
}
export const DELAY = {
    TOOLTIP: 500,
}
export const PAGINATION = {
    CURRENT_PAGE: 1,
    LIMIT: 40
}
export const COLOR = {
    u_title: '#1e2538',
    u_font: '#73788b',
    u_blue: '#007AFF',
    u_lightfont: '#c7c7c7',
    u_gray: '#e4e4e4',
    u_dark_gray: '#7b849e',
    u_datepicker_bg: '#fafbff',
    u_thead_bg: '#fafafb',
    u_icon_bg: '#4E525F',
    u_lightgreen: '#F8FDF8',
    u_darkfont: '#5D6372',
    u_semilight_gray: '#F8F9FE',
    u_white: '#FFFFFF',
    u_green: '#60B158',
    u_orange: '#FFA700',
    u_red: '#FF6961',
    u_light_slate_blue: '#9A5BFF',
}
export const STRING_LIST = {
    COUNTRY: ['Afghanistan', 'land Islands', 'Albania', 'Algeria', 'American Samoa', 'AndorrA', 'Angola', 'Anguilla', 'Antarctica', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Bouvet Island', 'Brazil', 'British Indian Ocean Territory', 'Brunei Darussalam', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cape Verde', 'Cayman Islands', 'Central African Republic', 'Chad', 'Chile', 'China', 'Christmas Island', 'Cocos (Keeling) Islands', 'Colombia', 'Comoros', 'Congo', 'Congo, The Democratic Republic of the', 'Cook Islands', 'Costa Rica', 'Cote D\'Ivoire', 'Croatia', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Falkland Islands (Malvinas)', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Guiana', 'French Polynesia', 'French Southern Territories', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guadeloupe', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Heard Island and Mcdonald Islands', 'Holy See (Vatican City State)', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran, Islamic Republic Of', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, Democratic People\'S Republic of', 'Korea, Republic of', 'Kuwait', 'Kyrgyzstan', 'Lao People\'S Democratic Republic', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libyan Arab Jamahiriya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macao', 'Macedonia, The Former Yugoslav Republic of', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Martinique', 'Mauritania', 'Mauritius', 'Mayotte', 'Mexico', 'Micronesia, Federated States of', 'Moldova, Republic of', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Myanmar', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Niue', 'Norfolk Island', 'Northern Mariana Islands', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territory, Occupied', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Pitcairn', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russian Federation', 'RWANDA', 'Saint Helena', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Pierre and Miquelon', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Georgia and the South Sandwich Islands', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Svalbard and Jan Mayen', 'Swaziland', 'Sweden', 'Switzerland', 'Syrian Arab Republic', 'Taiwan, Province of China', 'Tajikistan', 'Tanzania, United Republic of', 'Thailand', 'Timor-Leste', 'Togo', 'Tokelau', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks and Caicos Islands', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'United States Minor Outlying Islands', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Viet Nam', 'Virgin Islands, British', 'Virgin Islands, U.S.', 'Wallis and Futuna', 'Western Sahara', 'Yemen', 'Zambia', 'Zimbabwe'],
    COLOR: ['#60B158', '#007AFF', '#FFA700', '#FF6961', '#73788B', '#DC2ADE', '#2FB6CE', '#F25FA3', '#43D393', '#8C64FF', '#F4B377', '#757AFF', '#62B7E7', '#90D76F', '#ED93EF', '#7D5A5A', '#6886C5', '#F5B971', '#937D14', '#00BCD4', "#000000", "#0099ff", "#0E71C3", '#FF6961', '#73788B', '#DC2ADE']
}
export const LIST = {
    RECORD_PER_PAGE: [
        { value: 20, label: '20' },
        { value: 40, label: '40' },
        { value: 60, label: '60' },
        { value: 80, label: '80' },
        { value: 100, label: '100' },
    ],
    HOLIDAY_ICON: [
        { label: <Icon.Kite size={20} fill="#73788B" />, value: 'kite' },
        { label: <Icon.Holi size={20} fill="#73788B" />, value: 'holi' },
        { label: <Icon.Diwali size={20} fill="#73788B" />, value: 'diwali' },
        { label: <Icon.Christmas size={20} fill="#73788B" />, value: 'christmas' },
        { label: <Icon.SportsDay size={20} fill="#73788B" />, value: 'sportsDay' },
        { label: <Icon.RakshaBandhan size={20} fill="#73788B" />, value: 'rakshaBandhan' },
        { label: <Icon.Janmashtami size={20} fill="#73788B" />, value: 'janmashtami' },
        { label: <Icon.Ganesh size={20} fill="#73788B" />, value: 'ganesh' },
        { label: <Icon.Dussehra size={20} fill="#73788B" />, value: 'dussehra' },
        { label: <Icon.Navratri size={20} fill="#73788B" />, value: 'navratri' },
        { label: <Icon.Independence size={20} fill="#73788B" />, value: 'independence' },
        { label: <Icon.Republic size={20} fill="#73788B" />, value: 'republic' },
    ],
    LEAVE_ICON: [
        { label: <Icon.Annual size={20} fill="#73788B" />, value: 'AnnualLeaveIcon' },
        { label: <Icon.Lwp size={20} fill="#73788B" />, value: 'PaidLeaveIcon' },
        { label: <Icon.Casual size={20} fill="#73788B" />, value: 'CasualLeaveIcon' },
        { label: <Icon.Sick size={20} fill="#73788B" />, value: 'SickLeaveIcon' },
        { label: <Icon.Lwp size={20} fill="#73788B" />, value: 'LwpIcon' },
        { label: <Icon.Maternity size={20} fill="#73788B" />, value: 'MaternityLeaveIcon' },
        { label: <Icon.Marriage size={20} fill="#73788B" />, value: 'MarriageleaveIcon' },
        { label: <Icon.Bereavement size={20} fill="#73788B" />, value: 'BereavementLeaveIcon' },
        { label: <Icon.Compensatory size={20} fill="#73788B" />, value: 'CompensatoryLeaveIcon' },
        { label: <Icon.Paternity size={20} fill="#73788B" />, value: 'PaternityLeaveIcon' },
    ],
    COLOR: [
        { label: '#1d873f', value: '#1d873f' },
        { label: '#0f7fff', value: '#0f7fff' },
        { label: '#ffa801', value: '#ffa801' },
        { label: '#fe6f5e', value: '#fe6f5e' },
        { label: '#747880', value: '#747880' },
        { label: '#8e3b99', value: '#8e3b99' },
        { label: '#618b8c', value: '#618b8c' },
        { label: '#ff55a3', value: '#ff55a3' },
        { label: '#009e60', value: '#009e60' },
        { label: '#DF73FF', value: '#DF73FF' },
        { label: '#ffb871', value: '#ffb871' },
        { label: '#6495ed', value: '#6495ed' },
        { label: '#45b1e8', value: '#45b1e8' },
        { label: '#77dd77', value: '#77dd77' },
        { label: '#9c8e8e', value: '#9c8e8e' },
        { label: '#7F5417', value: '#7F5417' },
        { label: '#2377a2', value: '#2377a2' },
        { label: '#f3ac76', value: '#f3ac76' },
        { label: '#917214', value: '#917214' },
        { label: '#96ded1', value: '#96ded1' },
        { label: '#000000', value: '#000000' },
        { label: '#167f71', value: '#167f71' },
        { label: '#191970', value: '#191970' },
        { label: '#fe6f5e', value: '#fe6f5e' },
        { label: '#747880', value: '#747880' },
        { label: '#507389', value: '#507389' },
        { label: '#FFA700', value: '#FFA700' },
        { label: '#007AFF', value: '#007AFF' },
    ],
    COUNTRY: [
        { "name": "Afghanistan", "label": "Afghanistan", "dial_code": "+93", "code": "AF" },
        { "name": "Aland Islands", "label": "Aland Islands", "dial_code": "+358", "code": "AX" },
        { "name": "Albania", "label": "Albania", "dial_code": "+355", "code": "AL" },
        { "name": "Algeria", "label": "Algeria", "dial_code": "+213", "code": "DZ" },
        { "name": "Canada", "label": "Canada", "dial_code": "+1", "code": "CA" },
        { "name": "AmericanSamoa", "label": "AmericanSamoa", "dial_code": "+1684", "code": "AS" },
        { "name": "Andorra", "label": "Andorra", "dial_code": "+376", "code": "AD" },
        { "name": "Angola", "label": "Angola", "dial_code": "+244", "code": "AO" },
        { "name": "Anguilla", "label": "Anguilla", "dial_code": "+1264", "code": "AI" },
        { "name": "Antarctica", "label": "Antarctica", "dial_code": "+672", "code": "AQ" },
        { "name": "Antigua and Barbuda", "label": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG" },
        { "name": "Argentina", "label": "Argentina", "dial_code": "+54", "code": "AR" },
        { "name": "Armenia", "label": "Armenia", "dial_code": "+374", "code": "AM" },
        { "name": "Aruba", "label": "Aruba", "dial_code": "+297", "code": "AW" },
        { "name": "Australia", "label": "Australia", "dial_code": "+61", "code": "AU" },
        { "name": "Austria", "label": "Austria", "dial_code": "+43", "code": "AT" },
        { "name": "Azerbaijan", "label": "Azerbaijan", "dial_code": "+994", "code": "AZ" },
        { "name": "Bahamas", "label": "Bahamas", "dial_code": "+1242", "code": "BS" },
        { "name": "Bahrain", "label": "Bahrain", "dial_code": "+973", "code": "BH" },
        { "name": "Bangladesh", "label": "Bangladesh", "dial_code": "+880", "code": "BD" },
        { "name": "Barbados", "label": "Barbados", "dial_code": "+1246", "code": "BB" },
        { "name": "Belarus", "label": "Belarus", "dial_code": "+375", "code": "BY" },
        { "name": "Belgium", "label": "Belgium", "dial_code": "+32", "code": "BE" },
        { "name": "Belize", "label": "Belize", "dial_code": "+501", "code": "BZ" },
        { "name": "Benin", "label": "Benin", "dial_code": "+229", "code": "BJ" },
        { "name": "Bermuda", "label": "Bermuda", "dial_code": "+1441", "code": "BM" },
        { "name": "Bhutan", "label": "Bhutan", "dial_code": "+975", "code": "BT" },
        { "name": "Bolivia, Plurinational State of", "label": "Bolivia, Plurinational State of", "dial_code": "+591", "code": "BO" },
        { "name": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA" },
        { "name": "Botswana", "label": "Botswana", "dial_code": "+267", "code": "BW" },
        { "name": "Brazil", "label": "Brazil", "dial_code": "+55", "code": "BR" },
        { "name": "British Indian Ocean Territory", "label": "British Indian Ocean Territory", "dial_code": "+246", "code": "IO" },
        { "name": "Brunei Darussalam", "label": "Brunei Darussalam", "dial_code": "+673", "code": "BN" },
        { "name": "Bulgaria", "label": "Bulgaria", "dial_code": "+359", "code": "BG" },
        { "name": "Burkina Faso", "label": "Burkina Faso", "dial_code": "+226", "code": "BF" },
        { "name": "Burundi", "label": "Burundi", "dial_code": "+257", "code": "BI" },
        { "name": "Cambodia", "label": "Cambodia", "dial_code": "+855", "code": "KH" },
        { "name": "Cameroon", "label": "Cameroon", "dial_code": "+237", "code": "CM" },
        { "name": "Cape Verde", "label": "Cape Verde", "dial_code": "+238", "code": "CV" },
        { "name": "Cayman Islands", "label": "Cayman Islands", "dial_code": "+ 345", "code": "KY" },
        { "name": "Central African Republic", "label": "Central African Republic", "dial_code": "+236", "code": "CF" },
        { "name": "Chad", "label": "Chad", "dial_code": "+235", "code": "TD" },
        { "name": "Chile", "label": "Chile", "dial_code": "+56", "code": "CL" },
        { "name": "China", "label": "China", "dial_code": "+86", "code": "CN" },
        { "name": "Christmas Island", "label": "Christmas Island", "dial_code": "+61", "code": "CX" },
        { "name": "Cocos (Keeling) Islands", "label": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC" },
        { "name": "Colombia", "label": "Colombia", "dial_code": "+57", "code": "CO" },
        { "name": "Comoros", "label": "Comoros", "dial_code": "+269", "code": "KM" },
        { "name": "Congo", "label": "Congo", "dial_code": "+242", "code": "CG" },
        { "name": "Congo, The Democratic Republic of the Congo", "label": "Congo, The Democratic Republic of the Congo", "dial_code": "+243", "code": "CD" },
        { "name": "Cook Islands", "label": "Cook Islands", "dial_code": "+682", "code": "CK" },
        { "name": "Costa Rica", "label": "Costa Rica", "dial_code": "+506", "code": "CR" },
        { "name": "Cote d'Ivoire", "label": "Cote d'Ivoire", "dial_code": "+225", "code": "CI" },
        { "name": "Croatia", "label": "Croatia", "dial_code": "+385", "code": "HR" },
        { "name": "Cuba", "label": "Cuba", "dial_code": "+53", "code": "CU" },
        { "name": "Cyprus", "label": "Cyprus", "dial_code": "+357", "code": "CY" },
        { "name": "Czech Republic", "label": "Czech Republic", "dial_code": "+420", "code": "CZ" },
        { "name": "Denmark", "label": "Denmark", "dial_code": "+45", "code": "DK" },
        { "name": "Djibouti", "label": "Djibouti", "dial_code": "+253", "code": "DJ" },
        { "name": "Dominica", "label": "Dominica", "dial_code": "+1767", "code": "DM" },
        { "name": "Dominican Republic", "label": "Dominican Republic", "dial_code": "+1849", "code": "DO" },
        { "name": "Ecuador", "label": "Ecuador", "dial_code": "+593", "code": "EC" },
        { "name": "Egypt", "label": "Egypt", "dial_code": "+20", "code": "EG" },
        { "name": "El Salvador", "label": "El Salvador", "dial_code": "+503", "code": "SV" },
        { "name": "Equatorial Guinea", "label": "Equatorial Guinea", "dial_code": "+240", "code": "GQ" },
        { "name": "Eritrea", "label": "Eritrea", "dial_code": "+291", "code": "ER" },
        { "name": "Estonia", "label": "Estonia", "dial_code": "+372", "code": "EE" },
        { "name": "Ethiopia", "label": "Ethiopia", "dial_code": "+251", "code": "ET" },
        { "name": "Falkland Islands (Malvinas)", "label": "Falkland Islands (Malvinas)", "dial_code": "+500", "code": "FK" },
        { "name": "Faroe Islands", "label": "Faroe Islands", "dial_code": "+298", "code": "FO" },
        { "name": "Fiji", "label": "Fiji", "dial_code": "+679", "code": "FJ" },
        { "name": "Finland", "label": "Finland", "dial_code": "+358", "code": "FI" },
        { "name": "France", "label": "France", "dial_code": "+33", "code": "FR" },
        { "name": "French Guiana", "label": "French Guiana", "dial_code": "+594", "code": "GF" },
        { "name": "French Polynesia", "label": "French Polynesia", "dial_code": "+689", "code": "PF" },
        { "name": "Gabon", "label": "Gabon", "dial_code": "+241", "code": "GA" },
        { "name": "Gambia", "label": "Gambia", "dial_code": "+220", "code": "GM" },
        { "name": "Georgia", "label": "Georgia", "dial_code": "+995", "code": "GE" },
        { "name": "Germany", "label": "Germany", "dial_code": "+49", "code": "DE" },
        { "name": "Ghana", "label": "Ghana", "dial_code": "+233", "code": "GH" },
        { "name": "Gibraltar", "label": "Gibraltar", "dial_code": "+350", "code": "GI" },
        { "name": "Greece", "label": "Greece", "dial_code": "+30", "code": "GR" },
        { "name": "Greenland", "label": "Greenland", "dial_code": "+299", "code": "GL" },
        { "name": "Grenada", "label": "Grenada", "dial_code": "+1473", "code": "GD" },
        { "name": "Guadeloupe", "label": "Guadeloupe", "dial_code": "+590", "code": "GP" },
        { "name": "Guam", "label": "Guam", "dial_code": "+1671", "code": "GU" },
        { "name": "Guatemala", "label": "Guatemala", "dial_code": "+502", "code": "GT" },
        { "name": "Guernsey", "label": "Guernsey", "dial_code": "+44", "code": "GG" },
        { "name": "Guinea", "label": "Guinea", "dial_code": "+224", "code": "GN" },
        { "name": "Guinea-Bissau", "label": "Guinea-Bissau", "dial_code": "+245", "code": "GW" },
        { "name": "Guyana", "label": "Guyana", "dial_code": "+595", "code": "GY" },
        { "name": "Haiti", "label": "Haiti", "dial_code": "+509", "code": "HT" },
        { "name": "Holy See (Vatican City State)", "label": "Holy See (Vatican City State)", "dial_code": "+379", "code": "VA" },
        { "name": "Honduras", "label": "Honduras", "dial_code": "+504", "code": "HN" },
        { "name": "Hong Kong", "label": "Hong Kong", "dial_code": "+852", "code": "HK" },
        { "name": "Hungary", "label": "Hungary", "dial_code": "+36", "code": "HU" },
        { "name": "Iceland", "label": "Iceland", "dial_code": "+354", "code": "IS" },
        { "name": "India", "label": "India", "dial_code": "+91", "code": "IN" },
        { "name": "Indonesia", "label": "Indonesia", "dial_code": "+62", "code": "ID" },
        { "name": "Iran, Islamic Republic of Persian Gulf", "label": "Iran, Islamic Republic of Persian Gulf", "dial_code": "+98", "code": "IR" },
        { "name": "Iraq", "label": "Iraq", "dial_code": "+964", "code": "IQ" },
        { "name": "Ireland", "label": "Ireland", "dial_code": "+353", "code": "IE" },
        { "name": "Isle of Man", "label": "Isle of Man", "dial_code": "+44", "code": "IM" },
        { "name": "Israel", "label": "Israel", "dial_code": "+972", "code": "IL" },
        { "name": "Italy", "label": "Italy", "dial_code": "+39", "code": "IT" },
        { "name": "Jamaica", "label": "Jamaica", "dial_code": "+1876", "code": "JM" },
        { "name": "Japan", "label": "Japan", "dial_code": "+81", "code": "JP" },
        { "name": "Jersey", "label": "Jersey", "dial_code": "+44", "code": "JE" },
        { "name": "Jordan", "label": "Jordan", "dial_code": "+962", "code": "JO" },
        { "name": "Kazakhstan", "label": "Kazakhstan", "dial_code": "+77", "code": "KZ" },
        { "name": "Kenya", "label": "Kenya", "dial_code": "+254", "code": "KE" },
        { "name": "Kiribati", "label": "Kiribati", "dial_code": "+686", "code": "KI" },
        { "name": "Korea, Democratic People's Republic of Korea", "label": "Korea, Democratic People's Republic of Korea", "dial_code": "+850", "code": "KP" },
        { "name": "Korea, Republic of South Korea", "label": "Korea, Republic of South Korea", "dial_code": "+82", "code": "KR" },
        { "name": "Kuwait", "label": "Kuwait", "dial_code": "+965", "code": "KW" },
        { "name": "Kyrgyzstan", "label": "Kyrgyzstan", "dial_code": "+996", "code": "KG" },
        { "name": "Laos", "label": "Laos", "dial_code": "+856", "code": "LA" },
        { "name": "Latvia", "label": "Latvia", "dial_code": "+371", "code": "LV" },
        { "name": "Lebanon", "label": "Lebanon", "dial_code": "+961", "code": "LB" },
        { "name": "Lesotho", "label": "Lesotho", "dial_code": "+266", "code": "LS" },
        { "name": "Liberia", "label": "Liberia", "dial_code": "+231", "code": "LR" },
        { "name": "Libyan Arab Jamahiriya", "label": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY" },
        { "name": "Liechtenstein", "label": "Liechtenstein", "dial_code": "+423", "code": "LI" },
        { "name": "Lithuania", "label": "Lithuania", "dial_code": "+370", "code": "LT" },
        { "name": "Luxembourg", "label": "Luxembourg", "dial_code": "+352", "code": "LU" },
        { "name": "Macao", "label": "Macao", "dial_code": "+853", "code": "MO" },
        { "name": "Macedonia", "label": "Macedonia", "dial_code": "+389", "code": "MK" },
        { "name": "Madagascar", "label": "Madagascar", "dial_code": "+261", "code": "MG" },
        { "name": "Malawi", "label": "Malawi", "dial_code": "+265", "code": "MW" },
        { "name": "Malaysia", "label": "Malaysia", "dial_code": "+60", "code": "MY" },
        { "name": "Maldives", "label": "Maldives", "dial_code": "+960", "code": "MV" },
        { "name": "Mali", "label": "Mali", "dial_code": "+223", "code": "ML" },
        { "name": "Malta", "label": "Malta", "dial_code": "+356", "code": "MT" },
        { "name": "Marshall Islands", "label": "Marshall Islands", "dial_code": "+692", "code": "MH" },
        { "name": "Martinique", "label": "Martinique", "dial_code": "+596", "code": "MQ" },
        { "name": "Mauritania", "label": "Mauritania", "dial_code": "+222", "code": "MR" },
        { "name": "Mauritius", "label": "Mauritius", "dial_code": "+230", "code": "MU" },
        { "name": "Mayotte", "label": "Mayotte", "dial_code": "+262", "code": "YT" },
        { "name": "Mexico", "label": "Mexico", "dial_code": "+52", "code": "MX" },
        { "name": "Micronesia, Federated States of Micronesia", "label": "Micronesia, Federated States of Micronesia", "dial_code": "+691", "code": "FM" },
        { "name": "Moldova", "label": "Moldova", "dial_code": "+373", "code": "MD" },
        { "name": "Monaco", "label": "Monaco", "dial_code": "+377", "code": "MC" },
        { "name": "Mongolia", "label": "Mongolia", "dial_code": "+976", "code": "MN" },
        { "name": "Montenegro", "label": "Montenegro", "dial_code": "+382", "code": "ME" },
        { "name": "Montserrat", "label": "Montserrat", "dial_code": "+1664", "code": "MS" },
        { "name": "Morocco", "label": "Morocco", "dial_code": "+212", "code": "MA" },
        { "name": "Mozambique", "label": "Mozambique", "dial_code": "+258", "code": "MZ" },
        { "name": "Myanmar", "label": "Myanmar", "dial_code": "+95", "code": "MM" },
        { "name": "Namibia", "label": "Namibia", "dial_code": "+264", "code": "NA" },
        { "name": "Nauru", "label": "Nauru", "dial_code": "+674", "code": "NR" },
        { "name": "Nepal", "label": "Nepal", "dial_code": "+977", "code": "NP" },
        { "name": "Netherlands", "label": "Netherlands", "dial_code": "+31", "code": "NL" },
        { "name": "Netherlands Antilles", "label": "Netherlands Antilles", "dial_code": "+599", "code": "AN" },
        { "name": "New Caledonia", "label": "New Caledonia", "dial_code": "+687", "code": "NC" },
        { "name": "New Zealand", "label": "New Zealand", "dial_code": "+64", "code": "NZ" },
        { "name": "Nicaragua", "label": "Nicaragua", "dial_code": "+505", "code": "NI" },
        { "name": "Niger", "label": "Niger", "dial_code": "+227", "code": "NE" },
        { "name": "Nigeria", "label": "Nigeria", "dial_code": "+234", "code": "NG" },
        { "name": "Niue", "label": "Niue", "dial_code": "+683", "code": "NU" },
        { "name": "Norfolk Island", "label": "Norfolk Island", "dial_code": "+672", "code": "NF" },
        { "name": "Northern Mariana Islands", "label": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP" },
        { "name": "Norway", "label": "Norway", "dial_code": "+47", "code": "NO" },
        { "name": "Oman", "label": "Oman", "dial_code": "+968", "code": "OM" },
        { "name": "Pakistan", "label": "Pakistan", "dial_code": "+92", "code": "PK" },
        { "name": "Palau", "label": "Palau", "dial_code": "+680", "code": "PW" },
        { "name": "Palestinian Territory, Occupied", "label": "Palestinian Territory, Occupied", "dial_code": "+970", "code": "PS" },
        { "name": "Panama", "label": "Panama", "dial_code": "+507", "code": "PA" },
        { "name": "Papua New Guinea", "label": "Papua New Guinea", "dial_code": "+675", "code": "PG" },
        { "name": "Paraguay", "label": "Paraguay", "dial_code": "+595", "code": "PY" },
        { "name": "Peru", "label": "Peru", "dial_code": "+51", "code": "PE" },
        { "name": "Philippines", "label": "Philippines", "dial_code": "+63", "code": "PH" },
        { "name": "Pitcairn", "label": "Pitcairn", "dial_code": "+872", "code": "PN" },
        { "name": "Poland", "label": "Poland", "dial_code": "+48", "code": "PL" },
        { "name": "Portugal", "label": "Portugal", "dial_code": "+351", "code": "PT" },
        { "name": "Puerto Rico", "label": "Puerto Rico", "dial_code": "+1939", "code": "PR" },
        { "name": "Qatar", "label": "Qatar", "dial_code": "+974", "code": "QA" },
        { "name": "Romania", "label": "Romania", "dial_code": "+40", "code": "RO" },
        { "name": "Russia", "label": "Russia", "dial_code": "+7", "code": "RU" },
        { "name": "Rwanda", "label": "Rwanda", "dial_code": "+250", "code": "RW" },
        { "name": "Reunion", "label": "Reunion", "dial_code": "+262", "code": "RE" },
        { "name": "Saint Barthelemy", "label": "Saint Barthelemy", "dial_code": "+590", "code": "BL" },
        { "name": "Saint Helena, Ascension and Tristan Da Cunha", "label": "Saint Helena, Ascension and Tristan Da Cunha", "dial_code": "+290", "code": "SH" },
        { "name": "Saint Kitts and Nevis", "label": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN" },
        { "name": "Saint Lucia", "label": "Saint Lucia", "dial_code": "+1758", "code": "LC" },
        { "name": "Saint Martin", "label": "Saint Martin", "dial_code": "+590", "code": "MF" },
        { "name": "Saint Pierre and Miquelon", "label": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM" },
        { "name": "Saint Vincent and the Grenadines", "label": "Saint Vincent and the Grenadines", "dial_code": "+1784", "code": "VC" },
        { "name": "Samoa", "label": "Samoa", "dial_code": "+685", "code": "WS" },
        { "name": "San Marino", "label": "San Marino", "dial_code": "+378", "code": "SM" },
        { "name": "Sao Tome and Principe", "label": "Sao Tome and Principe", "dial_code": "+239", "code": "ST" },
        { "name": "Saudi Arabia", "label": "Saudi Arabia", "dial_code": "+966", "code": "SA" },
        { "name": "Senegal", "label": "Senegal", "dial_code": "+221", "code": "SN" },
        { "name": "Serbia", "label": "Serbia", "dial_code": "+381", "code": "RS" },
        { "name": "Seychelles", "label": "Seychelles", "dial_code": "+248", "code": "SC" },
        { "name": "Sierra Leone", "label": "Sierra Leone", "dial_code": "+232", "code": "SL" },
        { "name": "Singapore", "label": "Singapore", "dial_code": "+65", "code": "SG" },
        { "name": "Slovakia", "label": "Slovakia", "dial_code": "+421", "code": "SK" },
        { "name": "Slovenia", "label": "Slovenia", "dial_code": "+386", "code": "SI" },
        { "name": "Solomon Islands", "label": "Solomon Islands", "dial_code": "+677", "code": "SB" },
        { "name": "Somalia", "label": "Somalia", "dial_code": "+252", "code": "SO" },
        { "name": "South Africa", "label": "South Africa", "dial_code": "+27", "code": "ZA" },
        { "name": "South Sudan", "label": "South Sudan", "dial_code": "+211", "code": "SS" },
        { "name": "South Georgia and the South Sandwich Islands", "label": "South Georgia and the South Sandwich Islands", "dial_code": "+500", "code": "GS" },
        { "name": "Spain", "label": "Spain", "dial_code": "+34", "code": "ES" },
        { "name": "Sri Lanka", "label": "Sri Lanka", "dial_code": "+94", "code": "LK" },
        { "name": "Sudan", "label": "Sudan", "dial_code": "+249", "code": "SD" },
        { "name": "Suriname", "label": "Suriname", "dial_code": "+597", "code": "SR" },
        { "name": "Svalbard and Jan Mayen", "label": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ" },
        { "name": "Swaziland", "label": "Swaziland", "dial_code": "+268", "code": "SZ" },
        { "name": "Sweden", "label": "Sweden", "dial_code": "+46", "code": "SE" },
        { "name": "Switzerland", "label": "Switzerland", "dial_code": "+41", "code": "CH" },
        { "name": "Syrian Arab Republic", "label": "Syrian Arab Republic", "dial_code": "+963", "code": "SY" },
        { "name": "Taiwan", "label": "Taiwan", "dial_code": "+886", "code": "TW" },
        { "name": "Tajikistan", "label": "Tajikistan", "dial_code": "+992", "code": "TJ" },
        { "name": "Tanzania, United Republic of Tanzania", "label": "Tanzania, United Republic of Tanzania", "dial_code": "+255", "code": "TZ" },
        { "name": "Thailand", "label": "Thailand", "dial_code": "+66", "code": "TH" },
        { "name": "Timor-Leste", "label": "Timor-Leste", "dial_code": "+670", "code": "TL" },
        { "name": "Togo", "label": "Togo", "dial_code": "+228", "code": "TG" },
        { "name": "Tokelau", "label": "Tokelau", "dial_code": "+690", "code": "TK" },
        { "name": "Tonga", "label": "Tonga", "dial_code": "+676", "code": "TO" },
        { "name": "Trinidad and Tobago", "label": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT" },
        { "name": "Tunisia", "label": "Tunisia", "dial_code": "+216", "code": "TN" },
        { "name": "Turkey", "label": "Turkey", "dial_code": "+90", "code": "TR" },
        { "name": "Turkmenistan", "label": "Turkmenistan", "dial_code": "+993", "code": "TM" },
        { "name": "Turks and Caicos Islands", "label": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC" },
        { "name": "Tuvalu", "label": "Tuvalu", "dial_code": "+688", "code": "TV" },
        { "name": "Uganda", "label": "Uganda", "dial_code": "+256", "code": "UG" },
        { "name": "Ukraine", "label": "Ukraine", "dial_code": "+380", "code": "UA" },
        { "name": "United Arab Emirates", "label": "United Arab Emirates", "dial_code": "+971", "code": "AE" },
        { "name": "United Kingdom", "label": "United Kingdom", "dial_code": "+44", "code": "GB" },
        { "name": "United States", "label": "United States", "dial_code": "+1", "code": "US" },
        { "name": "Uruguay", "label": "Uruguay", "dial_code": "+598", "code": "UY" },
        { "name": "Uzbekistan", "label": "Uzbekistan", "dial_code": "+998", "code": "UZ" },
        { "name": "Vanuatu", "label": "Vanuatu", "dial_code": "+678", "code": "VU" },
        { "name": "Venezuela, Bolivarian Republic of Venezuela", "label": "Venezuela, Bolivarian Republic of Venezuela", "dial_code": "+58", "code": "VE" },
        { "name": "Vietnam", "label": "Vietnam", "dial_code": "+84", "code": "VN" },
        { "name": "Virgin Islands, British", "label": "Virgin Islands, British", "dial_code": "+1284", "code": "VG" },
        { "name": "Virgin Islands, U.S.", "label": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI" },
        { "name": "Wallis and Futuna", "label": "Wallis and Futuna", "dial_code": "+681", "code": "WF" },
        { "name": "Yemen", "label": "Yemen", "dial_code": "+967", "code": "YE" },
        { "name": "Zambia", "label": "Zambia", "dial_code": "+260", "code": "ZM" },
        { "name": "Zimbabwe", "label": "Zimbabwe", "dial_code": "+263", "code": "ZW" }
    ],
    STATE: [
        { "label": "Andhra Pradesh", "value": "Andhra Pradesh" },
        { "label": "Arunachal Pradesh", "value": "Arunachal Pradesh" },
        { "label": "Assam", "value": "Assam" },
        { "label": "Bihar", "value": "Bihar" },
        { "label": "Chhattisgarh", "value": "Chhattisgarh" },
        { "label": "Goa", "value": "Goa" },
        { "label": "Gujarat", "value": "Gujarat" },
        { "label": "Haryana", "value": "Haryana" },
        { "label": "Himachal Pradesh", "value": "Himachal Pradesh" },
        { "label": "Jammu and Kashmir", "value": "Jammu and Kashmir" },
        { "label": "Jharkhand", "value": "Jharkhand" },
        { "label": "Karnataka", "value": "Karnataka" },
        { "label": "Kerala", "value": "Kerala" },
        { "label": "Madhya Pradesh", "value": "Madhya Pradesh" },
        { "label": "Maharashtra", "value": "Maharashtra" },
        { "label": "Manipur", "value": "Manipur" },
        { "label": "Meghalaya", "value": "Meghalaya" },
        { "label": "Mizoram", "value": "Mizoram" },
        { "label": "Nagaland", "value": "Nagaland" },
        { "label": "Odisha", "value": "Odisha" },
        { "label": "Punjab", "value": "Punjab" },
        { "label": "Rajasthan", "value": "Rajasthan" },
        { "label": "Sikkim", "value": "Sikkim" },
        { "label": "Tamil Nadu", "value": "Tamil Nadu" },
        { "label": "Telangana", "value": "Telangana" },
        { "label": "Tripura", "value": "Tripura" },
        { "label": "Uttarakhand", "value": "Uttarakhand" },
        { "label": "Uttar Pradesh", "value": "Uttar Pradesh" },
        { "label": "West Bengal", "value": "West Bengal" },
        { "label": "Andaman and Nicobar Islands", "value": "Andaman and Nicobar Islands" },
        { "label": "Chandigarh", "value": "Chandigarh" },
        { "label": "Dadra and Nagar Haveli", "value": "Dadra and Nagar Haveli" },
        { "label": "Daman and Diu", "value": "Daman and Diu" },
        { "label": "Delhi", "value": "Delhi" },
        { "label": "Lakshadweep", "value": "Lakshadweep" },
        { "label": "Puducherry", "value": "Puducherry" },
    ],
    LANGUAGE: [
        { code: "ab", name: "Abkhaz", nativeName: "аҧсуа" },
        { code: "aa", name: "Afar", nativeName: "Afaraf" },
        { code: "af", name: "Afrikaans", nativeName: "Afrikaans" },
        { code: "ak", name: "Akan", nativeName: "Akan" },
        { code: "sq", name: "Albanian", nativeName: "Shqip" },
        { code: "am", name: "Amharic", nativeName: "አማርኛ" },
        { code: "ar", name: "Arabic", nativeName: "العربية" },
        { code: "an", name: "Aragonese", nativeName: "Aragonés" },
        { code: "hy", name: "Armenian", nativeName: "Հայերեն" },
        { code: "as", name: "Assamese", nativeName: "অসমীয়া" },
        { code: "av", name: "Avaric", nativeName: "авар мацӀ, магӀарул мацӀ" },
        { code: "ae", name: "Avestan", nativeName: "avesta" },
        { code: "ay", name: "Aymara", nativeName: "aymar aru" },
        { code: "az", name: "Azerbaijani", nativeName: "azərbaycan dili" },
        { code: "bm", name: "Bambara", nativeName: "bamanankan" },
        { code: "ba", name: "Bashkir", nativeName: "башҡорт теле" },
        { code: "eu", name: "Basque", nativeName: "euskara, euskera" },
        { code: "be", name: "Belarusian", nativeName: "Беларуская" },
        { code: "bn", name: "Bengali", nativeName: "বাংলা" },
        { code: "bh", name: "Bihari", nativeName: "भोजपुरी" },
        { code: "bi", name: "Bislama", nativeName: "Bislama" },
        { code: "bs", name: "Bosnian", nativeName: "bosanski jezik" },
        { code: "br", name: "Breton", nativeName: "brezhoneg" },
        { code: "bg", name: "Bulgarian", nativeName: "български език" },
        { code: "my", name: "Burmese", nativeName: "ဗမာစာ" },
        { code: "ca", name: "Catalan; Valencian", nativeName: "Català" },
        { code: "ch", name: "Chamorro", nativeName: "Chamoru" },
        { code: "ce", name: "Chechen", nativeName: "нохчийн мотт" },
        {
            code: "ny",
            name: "Chichewa; Chewa; Nyanja",
            nativeName: "chiCheŵa, chinyanja",
        },
        { code: "zh", name: "Chinese", nativeName: "中文 (Zhōngwén), 汉语, 漢語" },
        { code: "cv", name: "Chuvash", nativeName: "чӑваш чӗлхи" },
        { code: "kw", name: "Cornish", nativeName: "Kernewek" },
        { code: "co", name: "Corsican", nativeName: "corsu, lingua corsa" },
        { code: "cr", name: "Cree", nativeName: "ᓀᐦᐃᔭᐍᐏᐣ" },
        { code: "hr", name: "Croatian", nativeName: "hrvatski" },
        { code: "cs", name: "Czech", nativeName: "česky, čeština" },
        { code: "da", name: "Danish", nativeName: "dansk" },
        { code: "dv", name: "Divehi; Dhivehi; Maldivian;", nativeName: "ދިވެހި" },
        { code: "nl", name: "Dutch", nativeName: "Nederlands, Vlaams" },
        { code: "en", name: "English", nativeName: "English" },
        { code: "eo", name: "Esperanto", nativeName: "Esperanto" },
        { code: "et", name: "Estonian", nativeName: "eesti, eesti keel" },
        { code: "ee", name: "Ewe", nativeName: "Eʋegbe" },
        { code: "fo", name: "Faroese", nativeName: "føroyskt" },
        { code: "fj", name: "Fijian", nativeName: "vosa Vakaviti" },
        { code: "fi", name: "Finnish", nativeName: "suomi, suomen kieli" },
        { code: "fr", name: "French", nativeName: "français, langue française" },
        {
            code: "ff",
            name: "Fula; Fulah; Pulaar; Pular",
            nativeName: "Fulfulde, Pulaar, Pular",
        },
        { code: "gl", name: "Galician", nativeName: "Galego" },
        { code: "ka", name: "Georgian", nativeName: "ქართული" },
        { code: "de", name: "German", nativeName: "Deutsch" },
        { code: "el", name: "Greek, Modern", nativeName: "Ελληνικά" },
        { code: "gn", name: "Guaraní", nativeName: "Avañeẽ" },
        { code: "gu", name: "Gujarati", nativeName: "ગુજરાતી" },
        {
            code: "ht",
            name: "Haitian; Haitian Creole",
            nativeName: "Kreyòl ayisyen",
        },
        { code: "ha", name: "Hausa", nativeName: "Hausa, هَوُسَ" },
        { code: "he", name: "Hebrew (modern)", nativeName: "עברית" },
        { code: "hz", name: "Herero", nativeName: "Otjiherero" },
        { code: "hi", name: "Hindi", nativeName: "हिन्दी, हिंदी" },
        { code: "ho", name: "Hiri Motu", nativeName: "Hiri Motu" },
        { code: "hu", name: "Hungarian", nativeName: "Magyar" },
        { code: "ia", name: "Interlingua", nativeName: "Interlingua" },
        { code: "id", name: "Indonesian", nativeName: "Bahasa Indonesia" },
        {
            code: "ie",
            name: "Interlingue",
            nativeName: "Originally called Occidental; then Interlingue after WWII",
        },
        { code: "ga", name: "Irish", nativeName: "Gaeilge" },
        { code: "ig", name: "Igbo", nativeName: "Asụsụ Igbo" },
        { code: "ik", name: "Inupiaq", nativeName: "Iñupiaq, Iñupiatun" },
        { code: "io", name: "Ido", nativeName: "Ido" },
        { code: "is", name: "Icelandic", nativeName: "Íslenska" },
        { code: "it", name: "Italian", nativeName: "Italiano" },
        { code: "iu", name: "Inuktitut", nativeName: "ᐃᓄᒃᑎᑐᑦ" },
        {
            code: "ja",
            name: "Japanese",
            nativeName: "日本語 (にほんご／にっぽんご)",
        },
        { code: "jv", name: "Javanese", nativeName: "basa Jawa" },
        {
            code: "kl",
            name: "Kalaallisut, Greenlandic",
            nativeName: "kalaallisut, kalaallit oqaasii",
        },
        { code: "kn", name: "Kannada", nativeName: "ಕನ್ನಡ" },
        { code: "kr", name: "Kanuri", nativeName: "Kanuri" },
        { code: "ks", name: "Kashmiri", nativeName: "कश्मीरी, كشميري‎" },
        { code: "kk", name: "Kazakh", nativeName: "Қазақ тілі" },
        { code: "km", name: "Khmer", nativeName: "ភាសាខ្មែរ" },
        { code: "ki", name: "Kikuyu, Gikuyu", nativeName: "Gĩkũyũ" },
        { code: "rw", name: "Kinyarwanda", nativeName: "Ikinyarwanda" },
        { code: "ky", name: "Kirghiz, Kyrgyz", nativeName: "кыргыз тили" },
        { code: "kv", name: "Komi", nativeName: "коми кыв" },
        { code: "kg", name: "Kongo", nativeName: "KiKongo" },
        {
            code: "ko",
            name: "Korean",
            nativeName: "한국어 (韓國語), 조선말 (朝鮮語)",
        },
        { code: "ku", name: "Kurdish", nativeName: "Kurdî, كوردی‎" },
        { code: "kj", name: "Kwanyama, Kuanyama", nativeName: "Kuanyama" },
        { code: "la", name: "Latin", nativeName: "latine, lingua latina" },
        {
            code: "lb",
            name: "Luxembourgish, Letzeburgesch",
            nativeName: "Lëtzebuergesch",
        },
        { code: "lg", name: "Luganda", nativeName: "Luganda" },
        {
            code: "li",
            name: "Limburgish, Limburgan, Limburger",
            nativeName: "Limburgs",
        },
        { code: "ln", name: "Lingala", nativeName: "Lingála" },
        { code: "lo", name: "Lao", nativeName: "ພາສາລາວ" },
        { code: "lt", name: "Lithuanian", nativeName: "lietuvių kalba" },
        { code: "lu", name: "Luba-Katanga", nativeName: "" },
        { code: "lv", name: "Latvian", nativeName: "latviešu valoda" },
        { code: "gv", name: "Manx", nativeName: "Gaelg, Gailck" },
        { code: "mk", name: "Macedonian", nativeName: "македонски јазик" },
        { code: "mg", name: "Malagasy", nativeName: "Malagasy fiteny" },
        { code: "ms", name: "Malay", nativeName: "bahasa Melayu, بهاس ملايو‎" },
        { code: "ml", name: "Malayalam", nativeName: "മലയാളം" },
        { code: "mt", name: "Maltese", nativeName: "Malti" },
        { code: "mi", name: "Māori", nativeName: "te reo Māori" },
        { code: "mr", name: "Marathi (Marāṭhī)", nativeName: "मराठी" },
        { code: "mh", name: "Marshallese", nativeName: "Kajin M̧ajeļ" },
        { code: "mn", name: "Mongolian", nativeName: "монгол" },
        { code: "na", name: "Nauru", nativeName: "Ekakairũ Naoero" },
        {
            code: "nv",
            name: "Navajo, Navaho",
            nativeName: "Diné bizaad, Dinékʼehǰí",
        },
        { code: "nb", name: "Norwegian Bokmål", nativeName: "Norsk bokmål" },
        { code: "nd", name: "North Ndebele", nativeName: "isiNdebele" },
        { code: "ne", name: "Nepali", nativeName: "नेपाली" },
        { code: "ng", name: "Ndonga", nativeName: "Owambo" },
        { code: "nn", name: "Norwegian Nynorsk", nativeName: "Norsk nynorsk" },
        { code: "no", name: "Norwegian", nativeName: "Norsk" },
        { code: "ii", name: "Nuosu", nativeName: "ꆈꌠ꒿ Nuosuhxop" },
        { code: "nr", name: "South Ndebele", nativeName: "isiNdebele" },
        { code: "oc", name: "Occitan", nativeName: "Occitan" },
        { code: "oj", name: "Ojibwe, Ojibwa", nativeName: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
        {
            code: "cu",
            name:
                "Old Church Slavonic",
            nativeName: "ѩзыкъ словѣньскъ",
        },
        { code: "om", name: "Oromo", nativeName: "Afaan Oromoo" },
        { code: "or", name: "Oriya", nativeName: "ଓଡ଼ିଆ" },
        { code: "os", name: "Ossetian, Ossetic", nativeName: "ирон æвзаг" },
        { code: "pa", name: "Panjabi, Punjabi", nativeName: "ਪੰਜਾਬੀ, پنجابی‎" },
        { code: "pi", name: "Pāli", nativeName: "पाऴि" },
        { code: "fa", name: "Persian", nativeName: "فارسی" },
        { code: "pl", name: "Polish", nativeName: "polski" },
        { code: "ps", name: "Pashto, Pushto", nativeName: "پښتو" },
        { code: "pt", name: "Portuguese", nativeName: "Português" },
        { code: "qu", name: "Quechua", nativeName: "Runa Simi, Kichwa" },
        { code: "rm", name: "Romansh", nativeName: "rumantsch grischun" },
        { code: "rn", name: "Kirundi", nativeName: "kiRundi" },
        { code: "ro", name: "Romanian, Moldavian, Moldovan", nativeName: "română" },
        { code: "ru", name: "Russian", nativeName: "русский язык" },
        { code: "sa", name: "Sanskrit (Saṁskṛta)", nativeName: "संस्कृतम्" },
        { code: "sc", name: "Sardinian", nativeName: "sardu" },
        { code: "sd", name: "Sindhi", nativeName: "सिन्धी, سنڌي، سندھی‎" },
        { code: "se", name: "Northern Sami", nativeName: "Davvisámegiella" },
        { code: "sm", name: "Samoan", nativeName: "gagana faa Samoa" },
        { code: "sg", name: "Sango", nativeName: "yângâ tî sängö" },
        { code: "sr", name: "Serbian", nativeName: "српски језик" },
        { code: "gd", name: "Scottish Gaelic; Gaelic", nativeName: "Gàidhlig" },
        { code: "sn", name: "Shona", nativeName: "chiShona" },
        { code: "si", name: "Sinhala, Sinhalese", nativeName: "සිංහල" },
        { code: "sk", name: "Slovak", nativeName: "slovenčina" },
        { code: "sl", name: "Slovene", nativeName: "slovenščina" },
        { code: "so", name: "Somali", nativeName: "Soomaaliga, af Soomaali" },
        { code: "st", name: "Southern Sotho", nativeName: "Sesotho" },
        {
            code: "es",
            name: "Spanish; Castilian",
            nativeName: "español, castellano",
        },
        { code: "su", name: "Sundanese", nativeName: "Basa Sunda" },
        { code: "sw", name: "Swahili", nativeName: "Kiswahili" },
        { code: "ss", name: "Swati", nativeName: "SiSwati" },
        { code: "sv", name: "Swedish", nativeName: "svenska" },
        { code: "ta", name: "Tamil", nativeName: "தமிழ்" },
        { code: "te", name: "Telugu", nativeName: "తెలుగు" },
        { code: "tg", name: "Tajik", nativeName: "тоҷикӣ, toğikī, تاجیکی‎" },
        { code: "th", name: "Thai", nativeName: "ไทย" },
        { code: "ti", name: "Tigrinya", nativeName: "ትግርኛ" },
        {
            code: "bo",
            name: "Tibetan Standard, Tibetan, Central",
            nativeName: "བོད་ཡིག",
        },
        { code: "tk", name: "Turkmen", nativeName: "Türkmen, Түркмен" },
        { code: "tl", name: "Tagalog", nativeName: "Wikang Tagalog, ᜏᜒᜃᜅ᜔ ᜆᜄᜎᜓᜄ᜔" },
        { code: "tn", name: "Tswana", nativeName: "Setswana" },
        { code: "to", name: "Tonga (Tonga Islands)", nativeName: "faka Tonga" },
        { code: "tr", name: "Turkish", nativeName: "Türkçe" },
        { code: "ts", name: "Tsonga", nativeName: "Xitsonga" },
        { code: "tt", name: "Tatar", nativeName: "татарча, tatarça, تاتارچا‎" },
        { code: "tw", name: "Twi", nativeName: "Twi" },
        { code: "ty", name: "Tahitian", nativeName: "Reo Tahiti" },
        { code: "ug", name: "Uighur, Uyghur", nativeName: "Uyƣurqə, ئۇيغۇرچە‎" },
        { code: "uk", name: "Ukrainian", nativeName: "українська" },
        { code: "ur", name: "Urdu", nativeName: "اردو" },
        { code: "uz", name: "Uzbek", nativeName: "zbek, Ўзбек, أۇزبېك‎" },
        { code: "ve", name: "Venda", nativeName: "Tshivenḓa" },
        { code: "vi", name: "Vietnamese", nativeName: "Tiếng Việt" },
        { code: "vo", name: "Volapük", nativeName: "Volapük" },
        { code: "wa", name: "Walloon", nativeName: "Walon" },
        { code: "cy", name: "Welsh", nativeName: "Cymraeg" },
        { code: "wo", name: "Wolof", nativeName: "Wollof" },
        { code: "fy", name: "Western Frisian", nativeName: "Frysk" },
        { code: "xh", name: "Xhosa", nativeName: "isiXhosa" },
        { code: "yi", name: "Yiddish", nativeName: "ייִדיש" },
        { code: "yo", name: "Yoruba", nativeName: "Yorùbá" },
        { code: "za", name: "Zhuang, Chuang", nativeName: "Saɯ cueŋƅ, Saw cuengh" },
    ],
}
export const STAR_RATING = [
    {value: 5, label: '05'},
    {value: 10, label: '10'}
]
export const FILE = {
    IMAGES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i,
    VIDEO: /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i,
    AUDIO: /\.(mp3|wav|ogg|wma|m4a|flac|mp2|aac|aiff|m4r|amr|ac3|opus|gsm|wve|w64|caf|fssd|vox|dts|amb|txw|au|spx|wv|voc|tta|ra|oga|pvf|prc|maud|8svx|snd|sndr|sndt|avr|cdda|cvs|cvsd|cvu|dvms|vms|fap|paf|sou|gsrt|hcom|htk|ima|ircam|sln|sph|nist|smp|sd2)$/i,
    EXCLUDES: ['exe', 'EXE', 'dmg', 'msi'],
    DOCS: /\.(doc|docx|DOC|DOCX|pdf|PDF)$/i,
    // MIXFILES: /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi|doc|docx|DOC|DOCX|pdf|PDF)$/i,
    MIXFILES: /\.(png|apng|jpeg|jpg|pdf|PDF)$/i,
    MIXDOC: /\.(png|apng|jpeg|jpg|pdf|PDF|doc|docx|DOC|DOCX|xlsx|xls|rtf)$/i,
    ELSXFILES: /\.(xlsx|XLSX)$/i,
    ZIPFILE: /\.(zip)$/i,
};
export const FORMAT = {
    TIME: 'hh:mm A',
    MONTH: 'MM/YYYY',
    DATE: 'DD/MM/YYYY',
    DUE_DATE: 'DD MMM, YY',
    TICKET_DATE: 'DD MMM, YYYY',
    DAY_TIME: 'dddd hh:mm A',
    DATE_TIME: 'DD/MM/YYYY hh:mm A',
    FULL_DATE: 'dddd, MMMM D, YYYY',
    YEAR_MONTH: 'MMMM, YYYY',
    MONTH_DATE: 'MMM DD, YYYY',
    MONTH_DATE_TIME: 'MMM DD, YYYY, hh:mm A',
    DAY_DATE: 'ddd, MMM DD, YYYY',
    DOC_DATE_FORMAT: 'do, MMM yyyy',
    DAY_DATE_MONTH: 'ddd DD MMM, YYYY'
};
export const RECORDPERPAGE = [
    { value: 20, label: '20' },
    { value: 40, label: '40' },
    { value: 60, label: '60' },
    { value: 80, label: '80' },
    { value: 100, label: '100' },
];

export const COUNTRY_CODE = [
    {"name": "Afghanistan", "label": "Afghanistan", "dial_code": "+93", "code": "AF"},
    {"name": "Aland Islands", "label": "Aland Islands", "dial_code": "+358", "code": "AX"},
    {"name": "Albania", "label": "Albania", "dial_code": "+355", "code": "AL"},
    {"name": "Algeria", "label": "Algeria", "dial_code": "+213", "code": "DZ"},
    {"name": "Canada", "label": "Canada", "dial_code": "+1", "code": "CA"},
    {"name": "AmericanSamoa", "label": "AmericanSamoa", "dial_code": "+1684", "code": "AS"},
    {"name": "Andorra", "label": "Andorra", "dial_code": "+376", "code": "AD"},
    {"name": "Angola", "label": "Angola", "dial_code": "+244", "code": "AO"},
    {"name": "Anguilla", "label": "Anguilla", "dial_code": "+1264", "code": "AI"},
    {"name": "Antarctica", "label": "Antarctica", "dial_code": "+672", "code": "AQ"},
    {"name": "Antigua and Barbuda", "label": "Antigua and Barbuda", "dial_code": "+1268", "code": "AG"},
    {"name": "Argentina", "label": "Argentina", "dial_code": "+54", "code": "AR"},
    {"name": "Armenia", "label": "Armenia", "dial_code": "+374", "code": "AM"},
    {"name": "Aruba", "label": "Aruba", "dial_code": "+297", "code": "AW"},
    {"name": "Australia", "label": "Australia", "dial_code": "+61", "code": "AU"},
    {"name": "Austria", "label": "Austria", "dial_code": "+43", "code": "AT"},
    {"name": "Azerbaijan", "label": "Azerbaijan", "dial_code": "+994", "code": "AZ"},
    {"name": "Bahamas", "label": "Bahamas", "dial_code": "+1242", "code": "BS"},
    {"name": "Bahrain", "label": "Bahrain", "dial_code": "+973", "code": "BH"},
    {"name": "Bangladesh", "label": "Bangladesh", "dial_code": "+880", "code": "BD"},
    {"name": "Barbados", "label": "Barbados", "dial_code": "+1246", "code": "BB"},
    {"name": "Belarus", "label": "Belarus", "dial_code": "+375", "code": "BY"},
    {"name": "Belgium", "label": "Belgium", "dial_code": "+32", "code": "BE"},
    {"name": "Belize", "label": "Belize", "dial_code": "+501", "code": "BZ"},
    {"name": "Benin", "label": "Benin", "dial_code": "+229", "code": "BJ"},
    {"name": "Bermuda", "label": "Bermuda", "dial_code": "+1441", "code": "BM"},
    {"name": "Bhutan", "label": "Bhutan", "dial_code": "+975", "code": "BT"},
    {
        "name": "Bolivia, Plurinational State of",
        "label": "Bolivia, Plurinational State of",
        "dial_code": "+591",
        "code": "BO"
    },
    {"name": "Bosnia and Herzegovina", "label": "Bosnia and Herzegovina", "dial_code": "+387", "code": "BA"},
    {"name": "Botswana", "label": "Botswana", "dial_code": "+267", "code": "BW"},
    {"name": "Brazil", "label": "Brazil", "dial_code": "+55", "code": "BR"},
    {
        "name": "British Indian Ocean Territory",
        "label": "British Indian Ocean Territory",
        "dial_code": "+246",
        "code": "IO"
    },
    {"name": "Brunei Darussalam", "label": "Brunei Darussalam", "dial_code": "+673", "code": "BN"},
    {"name": "Bulgaria", "label": "Bulgaria", "dial_code": "+359", "code": "BG"},
    {"name": "Burkina Faso", "label": "Burkina Faso", "dial_code": "+226", "code": "BF"},
    {"name": "Burundi", "label": "Burundi", "dial_code": "+257", "code": "BI"},
    {"name": "Cambodia", "label": "Cambodia", "dial_code": "+855", "code": "KH"},
    {"name": "Cameroon", "label": "Cameroon", "dial_code": "+237", "code": "CM"},

    {"name": "Cape Verde", "label": "Cape Verde", "dial_code": "+238", "code": "CV"},
    {"name": "Cayman Islands", "label": "Cayman Islands", "dial_code": "+ 345", "code": "KY"},
    {"name": "Central African Republic", "label": "Central African Republic", "dial_code": "+236", "code": "CF"},
    {"name": "Chad", "label": "Chad", "dial_code": "+235", "code": "TD"},
    {"name": "Chile", "label": "Chile", "dial_code": "+56", "code": "CL"},
    {"name": "China", "label": "China", "dial_code": "+86", "code": "CN"},
    {"name": "Christmas Island", "label": "Christmas Island", "dial_code": "+61", "code": "CX"},
    {"name": "Cocos (Keeling) Islands", "label": "Cocos (Keeling) Islands", "dial_code": "+61", "code": "CC"},
    {"name": "Colombia", "label": "Colombia", "dial_code": "+57", "code": "CO"},
    {"name": "Comoros", "label": "Comoros", "dial_code": "+269", "code": "KM"},
    {"name": "Congo", "label": "Congo", "dial_code": "+242", "code": "CG"},
    {
        "name": "Congo, The Democratic Republic of the Congo",
        "label": "Congo, The Democratic Republic of the Congo",
        "dial_code": "+243",
        "code": "CD"
    },
    {"name": "Cook Islands", "label": "Cook Islands", "dial_code": "+682", "code": "CK"},
    {"name": "Costa Rica", "label": "Costa Rica", "dial_code": "+506", "code": "CR"},
    {"name": "Cote d'Ivoire", "label": "Cote d'Ivoire", "dial_code": "+225", "code": "CI"},
    {"name": "Croatia", "label": "Croatia", "dial_code": "+385", "code": "HR"},
    {"name": "Cuba", "label": "Cuba", "dial_code": "+53", "code": "CU"},
    {"name": "Cyprus", "label": "Cyprus", "dial_code": "+357", "code": "CY"},
    {"name": "Czech Republic", "label": "Czech Republic", "dial_code": "+420", "code": "CZ"},
    {"name": "Denmark", "label": "Denmark", "dial_code": "+45", "code": "DK"},
    {"name": "Djibouti", "label": "Djibouti", "dial_code": "+253", "code": "DJ"},
    {"name": "Dominica", "label": "Dominica", "dial_code": "+1767", "code": "DM"},
    {"name": "Dominican Republic", "label": "Dominican Republic", "dial_code": "+1849", "code": "DO"},
    {"name": "Ecuador", "label": "Ecuador", "dial_code": "+593", "code": "EC"},
    {"name": "Egypt", "label": "Egypt", "dial_code": "+20", "code": "EG"},
    {"name": "El Salvador", "label": "El Salvador", "dial_code": "+503", "code": "SV"},
    {"name": "Equatorial Guinea", "label": "Equatorial Guinea", "dial_code": "+240", "code": "GQ"},
    {"name": "Eritrea", "label": "Eritrea", "dial_code": "+291", "code": "ER"},
    {"name": "Estonia", "label": "Estonia", "dial_code": "+372", "code": "EE"},
    {"name": "Ethiopia", "label": "Ethiopia", "dial_code": "+251", "code": "ET"},
    {
        "name": "Falkland Islands (Malvinas)",
        "label": "Falkland Islands (Malvinas)",
        "dial_code": "+500",
        "code": "FK"
    },
    {"name": "Faroe Islands", "label": "Faroe Islands", "dial_code": "+298", "code": "FO"},
    {"name": "Fiji", "label": "Fiji", "dial_code": "+679", "code": "FJ"},
    {"name": "Finland", "label": "Finland", "dial_code": "+358", "code": "FI"},
    {"name": "France", "label": "France", "dial_code": "+33", "code": "FR"},
    {"name": "French Guiana", "label": "French Guiana", "dial_code": "+594", "code": "GF"},
    {"name": "French Polynesia", "label": "French Polynesia", "dial_code": "+689", "code": "PF"},
    {"name": "Gabon", "label": "Gabon", "dial_code": "+241", "code": "GA"},
    {"name": "Gambia", "label": "Gambia", "dial_code": "+220", "code": "GM"},
    {"name": "Georgia", "label": "Georgia", "dial_code": "+995", "code": "GE"},
    {"name": "Germany", "label": "Germany", "dial_code": "+49", "code": "DE"},
    {"name": "Ghana", "label": "Ghana", "dial_code": "+233", "code": "GH"},
    {"name": "Gibraltar", "label": "Gibraltar", "dial_code": "+350", "code": "GI"},
    {"name": "Greece", "label": "Greece", "dial_code": "+30", "code": "GR"},
    {"name": "Greenland", "label": "Greenland", "dial_code": "+299", "code": "GL"},
    {"name": "Grenada", "label": "Grenada", "dial_code": "+1473", "code": "GD"},
    {"name": "Guadeloupe", "label": "Guadeloupe", "dial_code": "+590", "code": "GP"},
    {"name": "Guam", "label": "Guam", "dial_code": "+1671", "code": "GU"},
    {"name": "Guatemala", "label": "Guatemala", "dial_code": "+502", "code": "GT"},
    {"name": "Guernsey", "label": "Guernsey", "dial_code": "+44", "code": "GG"},
    {"name": "Guinea", "label": "Guinea", "dial_code": "+224", "code": "GN"},
    {"name": "Guinea-Bissau", "label": "Guinea-Bissau", "dial_code": "+245", "code": "GW"},
    {"name": "Guyana", "label": "Guyana", "dial_code": "+595", "code": "GY"},
    {"name": "Haiti", "label": "Haiti", "dial_code": "+509", "code": "HT"},
    {
        "name": "Holy See (Vatican City State)",
        "label": "Holy See (Vatican City State)",
        "dial_code": "+379",
        "code": "VA"
    },
    {"name": "Honduras", "label": "Honduras", "dial_code": "+504", "code": "HN"},
    {"name": "Hong Kong", "label": "Hong Kong", "dial_code": "+852", "code": "HK"},
    {"name": "Hungary", "label": "Hungary", "dial_code": "+36", "code": "HU"},
    {"name": "Iceland", "label": "Iceland", "dial_code": "+354", "code": "IS"},
    {"name": "India", "label": "India", "dial_code": "+91", "code": "IN"},
    {"name": "Indonesia", "label": "Indonesia", "dial_code": "+62", "code": "ID"},
    {
        "name": "Iran, Islamic Republic of Persian Gulf",
        "label": "Iran, Islamic Republic of Persian Gulf",
        "dial_code": "+98",
        "code": "IR"
    },
    {"name": "Iraq", "label": "Iraq", "dial_code": "+964", "code": "IQ"},
    {"name": "Ireland", "label": "Ireland", "dial_code": "+353", "code": "IE"},
    {"name": "Isle of Man", "label": "Isle of Man", "dial_code": "+44", "code": "IM"},
    {"name": "Israel", "label": "Israel", "dial_code": "+972", "code": "IL"},
    {"name": "Italy", "label": "Italy", "dial_code": "+39", "code": "IT"},
    {"name": "Jamaica", "label": "Jamaica", "dial_code": "+1876", "code": "JM"},
    {"name": "Japan", "label": "Japan", "dial_code": "+81", "code": "JP"},
    {"name": "Jersey", "label": "Jersey", "dial_code": "+44", "code": "JE"},
    {"name": "Jordan", "label": "Jordan", "dial_code": "+962", "code": "JO"},
    {"name": "Kazakhstan", "label": "Kazakhstan", "dial_code": "+77", "code": "KZ"},
    {"name": "Kenya", "label": "Kenya", "dial_code": "+254", "code": "KE"},
    {"name": "Kiribati", "label": "Kiribati", "dial_code": "+686", "code": "KI"},
    {
        "name": "Korea, Democratic People's Republic of Korea",
        "label": "Korea, Democratic People's Republic of Korea",
        "dial_code": "+850",
        "code": "KP"
    },
    {
        "name": "Korea, Republic of South Korea",
        "label": "Korea, Republic of South Korea",
        "dial_code": "+82",
        "code": "KR"
    },
    {"name": "Kuwait", "label": "Kuwait", "dial_code": "+965", "code": "KW"},
    {"name": "Kyrgyzstan", "label": "Kyrgyzstan", "dial_code": "+996", "code": "KG"},
    {"name": "Laos", "label": "Laos", "dial_code": "+856", "code": "LA"},
    {"name": "Latvia", "label": "Latvia", "dial_code": "+371", "code": "LV"},
    {"name": "Lebanon", "label": "Lebanon", "dial_code": "+961", "code": "LB"},
    {"name": "Lesotho", "label": "Lesotho", "dial_code": "+266", "code": "LS"},
    {"name": "Liberia", "label": "Liberia", "dial_code": "+231", "code": "LR"},
    {"name": "Libyan Arab Jamahiriya", "label": "Libyan Arab Jamahiriya", "dial_code": "+218", "code": "LY"},
    {"name": "Liechtenstein", "label": "Liechtenstein", "dial_code": "+423", "code": "LI"},
    {"name": "Lithuania", "label": "Lithuania", "dial_code": "+370", "code": "LT"},
    {"name": "Luxembourg", "label": "Luxembourg", "dial_code": "+352", "code": "LU"},
    {"name": "Macao", "label": "Macao", "dial_code": "+853", "code": "MO"},
    {"name": "Macedonia", "label": "Macedonia", "dial_code": "+389", "code": "MK"},
    {"name": "Madagascar", "label": "Madagascar", "dial_code": "+261", "code": "MG"},
    {"name": "Malawi", "label": "Malawi", "dial_code": "+265", "code": "MW"},
    {"name": "Malaysia", "label": "Malaysia", "dial_code": "+60", "code": "MY"},
    {"name": "Maldives", "label": "Maldives", "dial_code": "+960", "code": "MV"},
    {"name": "Mali", "label": "Mali", "dial_code": "+223", "code": "ML"},
    {"name": "Malta", "label": "Malta", "dial_code": "+356", "code": "MT"},
    {"name": "Marshall Islands", "label": "Marshall Islands", "dial_code": "+692", "code": "MH"},
    {"name": "Martinique", "label": "Martinique", "dial_code": "+596", "code": "MQ"},
    {"name": "Mauritania", "label": "Mauritania", "dial_code": "+222", "code": "MR"},
    {"name": "Mauritius", "label": "Mauritius", "dial_code": "+230", "code": "MU"},
    {"name": "Mayotte", "label": "Mayotte", "dial_code": "+262", "code": "YT"},
    {"name": "Mexico", "label": "Mexico", "dial_code": "+52", "code": "MX"},
    {
        "name": "Micronesia, Federated States of Micronesia",
        "label": "Micronesia, Federated States of Micronesia",
        "dial_code": "+691",
        "code": "FM"
    },
    {"name": "Moldova", "label": "Moldova", "dial_code": "+373", "code": "MD"},
    {"name": "Monaco", "label": "Monaco", "dial_code": "+377", "code": "MC"},
    {"name": "Mongolia", "label": "Mongolia", "dial_code": "+976", "code": "MN"},
    {"name": "Montenegro", "label": "Montenegro", "dial_code": "+382", "code": "ME"},
    {"name": "Montserrat", "label": "Montserrat", "dial_code": "+1664", "code": "MS"},
    {"name": "Morocco", "label": "Morocco", "dial_code": "+212", "code": "MA"},
    {"name": "Mozambique", "label": "Mozambique", "dial_code": "+258", "code": "MZ"},
    {"name": "Myanmar", "label": "Myanmar", "dial_code": "+95", "code": "MM"},
    {"name": "Namibia", "label": "Namibia", "dial_code": "+264", "code": "NA"},
    {"name": "Nauru", "label": "Nauru", "dial_code": "+674", "code": "NR"},
    {"name": "Nepal", "label": "Nepal", "dial_code": "+977", "code": "NP"},
    {"name": "Netherlands", "label": "Netherlands", "dial_code": "+31", "code": "NL"},
    {"name": "Netherlands Antilles", "label": "Netherlands Antilles", "dial_code": "+599", "code": "AN"},
    {"name": "New Caledonia", "label": "New Caledonia", "dial_code": "+687", "code": "NC"},
    {"name": "New Zealand", "label": "New Zealand", "dial_code": "+64", "code": "NZ"},
    {"name": "Nicaragua", "label": "Nicaragua", "dial_code": "+505", "code": "NI"},
    {"name": "Niger", "label": "Niger", "dial_code": "+227", "code": "NE"},
    {"name": "Nigeria", "label": "Nigeria", "dial_code": "+234", "code": "NG"},
    {"name": "Niue", "label": "Niue", "dial_code": "+683", "code": "NU"},
    {"name": "Norfolk Island", "label": "Norfolk Island", "dial_code": "+672", "code": "NF"},
    {"name": "Northern Mariana Islands", "label": "Northern Mariana Islands", "dial_code": "+1670", "code": "MP"},
    {"name": "Norway", "label": "Norway", "dial_code": "+47", "code": "NO"},
    {"name": "Oman", "label": "Oman", "dial_code": "+968", "code": "OM"},
    {"name": "Pakistan", "label": "Pakistan", "dial_code": "+92", "code": "PK"},
    {"name": "Palau", "label": "Palau", "dial_code": "+680", "code": "PW"},
    {
        "name": "Palestinian Territory, Occupied",
        "label": "Palestinian Territory, Occupied",
        "dial_code": "+970",
        "code": "PS"
    },
    {"name": "Panama", "label": "Panama", "dial_code": "+507", "code": "PA"},
    {"name": "Papua New Guinea", "label": "Papua New Guinea", "dial_code": "+675", "code": "PG"},
    {"name": "Paraguay", "label": "Paraguay", "dial_code": "+595", "code": "PY"},
    {"name": "Peru", "label": "Peru", "dial_code": "+51", "code": "PE"},
    {"name": "Philippines", "label": "Philippines", "dial_code": "+63", "code": "PH"},
    {"name": "Pitcairn", "label": "Pitcairn", "dial_code": "+872", "code": "PN"},
    {"name": "Poland", "label": "Poland", "dial_code": "+48", "code": "PL"},
    {"name": "Portugal", "label": "Portugal", "dial_code": "+351", "code": "PT"},
    {"name": "Puerto Rico", "label": "Puerto Rico", "dial_code": "+1939", "code": "PR"},
    {"name": "Qatar", "label": "Qatar", "dial_code": "+974", "code": "QA"},
    {"name": "Romania", "label": "Romania", "dial_code": "+40", "code": "RO"},
    {"name": "Russia", "label": "Russia", "dial_code": "+7", "code": "RU"},
    {"name": "Rwanda", "label": "Rwanda", "dial_code": "+250", "code": "RW"},
    {"name": "Reunion", "label": "Reunion", "dial_code": "+262", "code": "RE"},
    {"name": "Saint Barthelemy", "label": "Saint Barthelemy", "dial_code": "+590", "code": "BL"},
    {
        "name": "Saint Helena, Ascension and Tristan Da Cunha",
        "label": "Saint Helena, Ascension and Tristan Da Cunha",
        "dial_code": "+290",
        "code": "SH"
    },
    {"name": "Saint Kitts and Nevis", "label": "Saint Kitts and Nevis", "dial_code": "+1869", "code": "KN"},
    {"name": "Saint Lucia", "label": "Saint Lucia", "dial_code": "+1758", "code": "LC"},
    {"name": "Saint Martin", "label": "Saint Martin", "dial_code": "+590", "code": "MF"},
    {"name": "Saint Pierre and Miquelon", "label": "Saint Pierre and Miquelon", "dial_code": "+508", "code": "PM"},
    {
        "name": "Saint Vincent and the Grenadines",
        "label": "Saint Vincent and the Grenadines",
        "dial_code": "+1784",
        "code": "VC"
    },
    {"name": "Samoa", "label": "Samoa", "dial_code": "+685", "code": "WS"},
    {"name": "San Marino", "label": "San Marino", "dial_code": "+378", "code": "SM"},
    {"name": "Sao Tome and Principe", "label": "Sao Tome and Principe", "dial_code": "+239", "code": "ST"},
    {"name": "Saudi Arabia", "label": "Saudi Arabia", "dial_code": "+966", "code": "SA"},
    {"name": "Senegal", "label": "Senegal", "dial_code": "+221", "code": "SN"},
    {"name": "Serbia", "label": "Serbia", "dial_code": "+381", "code": "RS"},
    {"name": "Seychelles", "label": "Seychelles", "dial_code": "+248", "code": "SC"},
    {"name": "Sierra Leone", "label": "Sierra Leone", "dial_code": "+232", "code": "SL"},
    {"name": "Singapore", "label": "Singapore", "dial_code": "+65", "code": "SG"},
    {"name": "Slovakia", "label": "Slovakia", "dial_code": "+421", "code": "SK"},
    {"name": "Slovenia", "label": "Slovenia", "dial_code": "+386", "code": "SI"},
    {"name": "Solomon Islands", "label": "Solomon Islands", "dial_code": "+677", "code": "SB"},
    {"name": "Somalia", "label": "Somalia", "dial_code": "+252", "code": "SO"},
    {"name": "South Africa", "label": "South Africa", "dial_code": "+27", "code": "ZA"},
    {"name": "South Sudan", "label": "South Sudan", "dial_code": "+211", "code": "SS"},
    {
        "name": "South Georgia and the South Sandwich Islands",
        "label": "South Georgia and the South Sandwich Islands",
        "dial_code": "+500",
        "code": "GS"
    },
    {"name": "Spain", "label": "Spain", "dial_code": "+34", "code": "ES"},
    {"name": "Sri Lanka", "label": "Sri Lanka", "dial_code": "+94", "code": "LK"},
    {"name": "Sudan", "label": "Sudan", "dial_code": "+249", "code": "SD"},
    {"name": "Suriname", "label": "Suriname", "dial_code": "+597", "code": "SR"},
    {"name": "Svalbard and Jan Mayen", "label": "Svalbard and Jan Mayen", "dial_code": "+47", "code": "SJ"},
    {"name": "Swaziland", "label": "Swaziland", "dial_code": "+268", "code": "SZ"},
    {"name": "Sweden", "label": "Sweden", "dial_code": "+46", "code": "SE"},
    {"name": "Switzerland", "label": "Switzerland", "dial_code": "+41", "code": "CH"},
    {"name": "Syrian Arab Republic", "label": "Syrian Arab Republic", "dial_code": "+963", "code": "SY"},
    {"name": "Taiwan", "label": "Taiwan", "dial_code": "+886", "code": "TW"},
    {"name": "Tajikistan", "label": "Tajikistan", "dial_code": "+992", "code": "TJ"},
    {
        "name": "Tanzania, United Republic of Tanzania",
        "label": "Tanzania, United Republic of Tanzania",
        "dial_code": "+255",
        "code": "TZ"
    },
    {"name": "Thailand", "label": "Thailand", "dial_code": "+66", "code": "TH"},
    {"name": "Timor-Leste", "label": "Timor-Leste", "dial_code": "+670", "code": "TL"},
    {"name": "Togo", "label": "Togo", "dial_code": "+228", "code": "TG"},
    {"name": "Tokelau", "label": "Tokelau", "dial_code": "+690", "code": "TK"},
    {"name": "Tonga", "label": "Tonga", "dial_code": "+676", "code": "TO"},
    {"name": "Trinidad and Tobago", "label": "Trinidad and Tobago", "dial_code": "+1868", "code": "TT"},
    {"name": "Tunisia", "label": "Tunisia", "dial_code": "+216", "code": "TN"},
    {"name": "Turkey", "label": "Turkey", "dial_code": "+90", "code": "TR"},
    {"name": "Turkmenistan", "label": "Turkmenistan", "dial_code": "+993", "code": "TM"},
    {"name": "Turks and Caicos Islands", "label": "Turks and Caicos Islands", "dial_code": "+1649", "code": "TC"},
    {"name": "Tuvalu", "label": "Tuvalu", "dial_code": "+688", "code": "TV"},
    {"name": "Uganda", "label": "Uganda", "dial_code": "+256", "code": "UG"},
    {"name": "Ukraine", "label": "Ukraine", "dial_code": "+380", "code": "UA"},
    {"name": "United Arab Emirates", "label": "United Arab Emirates", "dial_code": "+971", "code": "AE"},
    {"name": "United Kingdom", "label": "United Kingdom", "dial_code": "+44", "code": "GB"},
    {"name": "United States", "label": "United States", "dial_code": "+1", "code": "US"},
    {"name": "Uruguay", "label": "Uruguay", "dial_code": "+598", "code": "UY"},
    {"name": "Uzbekistan", "label": "Uzbekistan", "dial_code": "+998", "code": "UZ"},
    {"name": "Vanuatu", "label": "Vanuatu", "dial_code": "+678", "code": "VU"},
    {
        "name": "Venezuela, Bolivarian Republic of Venezuela",
        "label": "Venezuela, Bolivarian Republic of Venezuela",
        "dial_code": "+58",
        "code": "VE"
    },
    {"name": "Vietnam", "label": "Vietnam", "dial_code": "+84", "code": "VN"},
    {"name": "Virgin Islands, British", "label": "Virgin Islands, British", "dial_code": "+1284", "code": "VG"},
    {"name": "Virgin Islands, U.S.", "label": "Virgin Islands, U.S.", "dial_code": "+1340", "code": "VI"},
    {"name": "Wallis and Futuna", "label": "Wallis and Futuna", "dial_code": "+681", "code": "WF"},
    {"name": "Yemen", "label": "Yemen", "dial_code": "+967", "code": "YE"},
    {"name": "Zambia", "label": "Zambia", "dial_code": "+260", "code": "ZM"},
    {"name": "Zimbabwe", "label": "Zimbabwe", "dial_code": "+263", "code": "ZW"}
];